import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { Badge, BadgePriority } from '..';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { classes } from './Badge.visual.st.css';
import { VideoFill } from '@wix/wix-ui-icons-common/on-stage';
import { CameraIcon } from './CameraIcon';

class BadgeVisual extends React.Component<any> {
  render() {
    return (
      <VisualTestContainer>
        <Badge {...this.props} />
      </VisualTestContainer>
    );
  }
}

const tests = [
  {
    describe: 'basic',
    its: [
      {
        it: 'default',
        props: {
          priority: BadgePriority.default,
          children: ['Default'],
        },
      },
      {
        it: 'primary',
        props: {
          priority: BadgePriority.primary,
          children: ['Primary'],
        },
      },
      {
        it: 'light',
        props: {
          priority: BadgePriority.light,
          children: ['Light'],
        },
      },
      {
        it: 'secondary',
        props: {
          priority: BadgePriority.secondary,
          children: ['secondary'],
        },
      },
      {
        it: 'style params override - from palette',
        props: {
          className: classes.palette,
          children: ['Style Params Override'],
        },
      },
      {
        it: 'style params override - static',
        props: {
          className: classes.staticColors,
          children: ['Style Params Override'],
        },
      },
      {
        it: 'style params override - from palette - optimized',
        props: {
          className: classes.paletteStyleParams,
          children: ['Style Params Override'],
        },
      },
      {
        it: 'style params override - static - optimized',
        props: {
          className: classes.staticColorsSiteParams,
          children: ['Style Params Override'],
        },
      },
      {
        it: 'style params override with icon',
        props: {
          className: classes.palette,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'change the icon color',
        props: {
          className: classes.iconColor,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'change the icon and text color',
        props: {
          className: classes.iconAndTextColor,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'custom icon and change text color',
        props: {
          className: classes.iconAndTextColor,
          children: ['Style Params Override'],
          icon: <CameraIcon />,
        },
      },
      {
        it: 'change font',
        props: {
          className: classes.font,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'no corner radius',
        props: {
          className: classes.noCornerRadius,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'different corner radius',
        props: {
          className: classes.differentCornerRadius,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'no border width',
        props: {
          className: classes.noWidth,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'border width and color',
        props: {
          className: classes.widthAndColor,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'no spacing',
        props: {
          className: classes.noSpacing,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'spacing',
        props: {
          className: classes.spacing,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'spacing without icon',
        props: {
          className: classes.spacingWithoutIcon,
          children: ['Style Params Override'],
        },
      },
      {
        it: 'large icon size',
        props: {
          className: classes.iconSize,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: '0 icon size',
        props: {
          className: classes.zeroIconSize,
          children: ['Style Params Override'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'inner icon size',
        props: {
          className: classes.innerIconSize,
          children: ['Style Params Override'],
          icon: (
            <div>
              <VideoFill />
            </div>
          ),
        },
      },
      {
        it: 'default wst override',
        props: {
          className: classes.wstOverride,
          priority: BadgePriority.default,
          children: ['Default'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'primary wst override',
        props: {
          className: classes.wstOverride,
          priority: BadgePriority.primary,
          children: ['Primary'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'light wst override',
        props: {
          className: classes.wstOverride,
          priority: BadgePriority.light,
          children: ['Light'],
          icon: <VideoFill />,
        },
      },
      {
        it: 'secondary wst override',
        props: {
          className: classes.wstOverride,
          priority: BadgePriority.secondary,
          children: ['Secondary'],
          icon: <VideoFill />,
        },
      },
    ],
  },
];

tests.forEach(({ describe, its }) => {
  its.forEach(({ it, props }) => {
    storiesOf(`Badge/${describe}`, module).add(it, () => (
      <BadgeVisual {...props} />
    ));
  });
});
